// Filename: views/layout/supervisor.js
define('views/modules/dashboard/graph/graph',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // Views
    'views/parts/info-section',
    'views/modules/dashboard/graph/graph-content',
    // Templates
    'text!templates/modules/dashboard/graph/graph.html'
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // Views
    VInfoSection,
    VGraphContent,
    // Templates
    TDashboardGraph
) {

    var VDashboardGraph = Backbone.View.extend({
        template: TDashboardGraph,

        regions: {
            content: ".graph-content",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.url = this.options.url;

            var view = this.view = {
                info: new VInfoSection({
                    title: "graph:Your graphs",
                    content: this.template,
                    // buttonTop: {
                    //     link: '#/' + this.url,
                    //     text: 'Show more graphs',
                    //     displayIcon: false,
                    // }
                }),
                content: new VGraphContent({
                    profile: this.model
                })
            };

        },

        render: function() {

            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.content, zone.$content);

            return this;
        },

        onResize: function(e, width) {
            var view = this.view.content;
            if (view.onResize) {
                view.onResize(e, width);
            }
        },

    });

    return VDashboardGraph;

});

